import { Controller } from "@hotwired/stimulus";

// Shows a warning message when the typeface select is set to a value flagged
// as low-legibility for body text.
export default class extends Controller {
  static targets = ["select", "warning"];
  static values = {
    triggers: { type: Array, default: [] },
  };

  connect() {
    this.toggle();
  }

  toggle() {
    const flagged = this.triggersValue.includes(this.selectTarget.value);
    this.warningTarget.hidden = !flagged;
  }
}
